/** Signup URL that returns users to billing with the buy-credits modal open. */
export const SIGNUP_REDIRECT_TO_BILLING_MODAL = `/signup?redirectTo=${encodeURIComponent(
  "/app/billing?openBuyCredits=1"
)}`;

/**
 * Validates `redirectTo` query values so we only send users to in-app paths
 * (avoids open redirects via /signup?redirectTo=https://evil.com).
 */
export function getSafeAppRedirect(value: unknown): string | null {
  if (typeof value !== "string" || value.length === 0) {
    return null;
  }
  let path = value;
  try {
    path = decodeURIComponent(value);
  } catch {
    return null;
  }
  if (!path.startsWith("/")) {
    return null;
  }
  if (!path.startsWith("/app/")) {
    return null;
  }
  if (path.includes("//") || path.includes("..")) {
    return null;
  }
  return path;
}
